import request from "@/utils/newServer";
export default function iiotExport(reqInfo) {
	return request({
		url: '/expExcel/doExport/'+reqInfo.params.exportCode,
		method: 'post',
		responseType: 'blob',
		data: {
			"id": "99u8239",
			"data": reqInfo.esayInfo
		}
	})
}
